// extracted by mini-css-extract-plugin
module.exports = {"link":"pzan","text":"gBkj","selected":"Oxrx","icon":"HSK-"};